import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ComponentType } from "@model";

@Injectable({ providedIn: "root" })
export class PopupService {
  private _toShowComponent$ = new Subject<ComponentType | null>();
  toShowComponent$ = this._toShowComponent$.asObservable();

  showPopup(component: ComponentType) {
    this._toShowComponent$.next(component);
  }

  closePopup() {
    this._toShowComponent$.next(null);
  }
}
